import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {AccessService} from './access.service';
import {LocalStorageService} from "./local-storage.service";
import {Router} from "@angular/router";
import Swal from "sweetalert2";
import {environment} from "../../environments/environment.prod";

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private http = inject(HttpClient);
    private toastrService = inject(ToastrService);
    private accessService = inject(AccessService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);

    showingReload = false;

    request(action: string, dataObject: object|null = null): Observable<any> {
        return this.http
            .post('api/api.php', {
                action,
                data: dataObject,
            }, {
                headers: {"Authorization": this.accessService.token}
            })
            .pipe(
                tap((response: any) => {
                    if (response?.errors) {
                        response.errors.forEach((error: any) => {
                            this.toastrService.error(error, 'Fehler');
                        });
                    }

                    if (response?.invalid_token) {
                        this.localStorageService.removeItem('token');
                        this.accessService.token = '';
                        this.accessService.user = null;
                        this.router.navigate(['/login']);
                    }

                    /*let localVersion = environment.appVersion;
                    // remove trailing "-dev" or "-local" from localVersion
                    localVersion = localVersion.replace(/-dev|-local$/, '');

                    if (response.version && response.version !== localVersion && !this.showingReload) {
                        this.showingReload = true;
                        Swal.fire({
                            title: 'Neue Version verfügbar',
                            text: 'Eine neue Version der Anwendung ist verfügbar. Möchtest Du die Seite neu laden?',
                            icon: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Neu laden',
                            cancelButtonText: 'Später'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.showingReload = false;
                                window.location.reload();
                            }
                        });
                    }*/

                })
            );
    }

    generateBlob(response: any) {
        const byteCharacters = atob(response.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: response.mime || 'text/csv;charset=utf-8'});
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = response.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }
}




